import React from 'react';
import { createRoot } from 'react-dom/client'
import { ConfigProvider } from './contexts/ConfigContext';
import { UserProvider } from './contexts/UserContext';
import { CompanyProvider } from './contexts/CompanyContext';
import Routes from './Routes';
import './index.css'

const domNode = document.getElementById('root') as HTMLElement
const root = createRoot(domNode)

root.render(
  <React.StrictMode>
    <ConfigProvider>
      <UserProvider>
        <CompanyProvider>
          <Routes />
        </CompanyProvider>
      </UserProvider>
    </ConfigProvider>
  </React.StrictMode>
)
